<script setup lang="ts">
import { ref, onMounted, defineProps, withDefaults, defineEmits } from 'vue';
import vueFilePond, { setOptions } from 'vue-filepond';

// Styles
// Import FilePond styles
import "filepond/dist/filepond.min.css";
// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";


// Plugins
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileEncode,
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview,
);

const props = defineProps({
  modelValue: {
    default: [],
    type: Array,
  }
});

const files = ref([]);
const pond = ref(null);

const server = {
  process: (fieldName, file, metadata, load, error, progress, abort) => {
    load(file.name);
  }
};

const emit = defineEmits(['update:modelValue']);

const handleFilePondInit = () => {
  if (!pond.value) return;
  
  // @ts-ignore
  pond.value.getFiles().forEach(file => {
    file.getMetadata('fileEncodeResults').then(result => {
      const loadedFile = {
        file: file.file,
        content: result.content,
        metadata: file.getMetadata()
      };
      // @ts-ignore
      files.value.push(loadedFile);
    });
  });
  
  emit('update:modelValue', files.value);
};

// ensure the init function is called when the component is mounted
onMounted(handleFilePondInit);
</script>
<template>
  <div>
    <file-pond
      ref="pond"
      name="test"
      label-idle="Selectionner un fichier"
      allow-multiple="true"
      acceptedFileTypes="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/jpeg,image/png"
      :server="server"
      :files="files"
      :instantUpload="false"
      @init="handleFilePondInit"
    />
  </div>
</template>
<style >
.filepond--credits {
  display: none;
}

.filepond--wrapper {
  border-radius: 0.75rem;
  border-style: dotted;
}

.filepond--drop-label {
  cursor: pointer;
}

/* .filepond--drop-label {
  display: none;
} */
</style>